import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BarChart } from '../../../shared';
import { Box, Skeleton, Typography } from '@mui/material';
import _ from 'lodash';
import { REPEAT_ENGAGEMENT_CHART_OPTIONS } from './constants';
import useChartOptions from '../../../../utility/hooks/useChartOptions';

const RepeatEngagementDistribution = () => {
    const { isLoading, repeatEngagementBarChart } = useSelector(
        (state) => state.digitalEngagement
    );
    const { data, categories } = repeatEngagementBarChart;

    const chartOptions = useChartOptions(
        REPEAT_ENGAGEMENT_CHART_OPTIONS,
        {
            xaxis: { categories: categories || [] },
            plotOptions: { bar: { columnWidth: categories?.length > 10 ? '40%' : '50px' } }
        },
        [categories]
    );

    return (
        <Box className="container-p-24-br-16 bg-gray-50">
            <Box>
                <Typography className="text-md-medium gray-900">
          Repeat Engagement Distribution
                </Typography>
            </Box>
            {isLoading ? (
                <Skeleton height={400} variant="rectangular" width="100%" />
            ) : (
                <BarChart
                    chartOptions={chartOptions}
                    chartSeries={_.cloneDeep(data)}
                    height={'400px'}
                    key={JSON.stringify(data)}
                />
            )}
        </Box>
    );
};

export default RepeatEngagementDistribution;
